import styled from 'styled-components';

import {
  colorBlack900,
  colorBorder,
  colorWhite,
  fontFamilySecondary,
  mediaQueryDesktopMin,
} from '@/styleUtils';

export const TableComponent = styled.table`
  background-color: ${colorWhite};
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${colorBlack900};
  padding: 24px 16px;
  margin: 0;

  &:not(:last-child) {
    box-shadow: 0 -1px 0 0 ${colorBorder} inset;
  }

  @media ${mediaQueryDesktopMin} {
    padding: 24px;
  }
`;

export const TableTitle = styled.caption`
  font: 700 20px/28px ${fontFamilySecondary};
  margin-bottom: 12px;
`;
